export default __webpack_public_path__ + "static/media/positive.dfa9afec.svg";